import React, { FC, ReactNode } from 'react';

import DocumentsIcon from '../../assets/icons/documents';
import ExchangeIcon from '../../assets/icons/exchange-icon';
import BalanceHeaderContainer from '../../containers/account/balance-header-container';
import Breadcrumbs from '../breadcumbs/breadcrumbs';
import AgentsIcon from './icons/agents-icon.svg';
import AssetsIcon from './icons/assets-icon.svg';
import HistoryIcon from './icons/history-icon.svg';
import MainIcon from './icons/main-icon.svg';
import OrdersIcon from './icons/orders-icon.svg';
import CompanyIcon from 'assets/icons/company.svg';
import './page-header.scss';

interface PageHeaderProps {
  items?: { link: string; title: string }[];
  isHideBalanceInformer?: boolean;
  iconType?:
    | 'order'
    | 'history'
    | 'assets'
    | 'documents'
    | 'main'
    | 'agents'
    | 'exchange'
    | 'company';
  tabName?: string;
}

const PageHeader: FC<PageHeaderProps> = ({
  items,
  isHideBalanceInformer,
  iconType,
  tabName,
}) => {
  let icon: ReactNode | string;

  switch (iconType) {
    case 'assets':
      icon = AssetsIcon;
      break;
    case 'history':
      icon = HistoryIcon;
      break;
    case 'order':
      icon = OrdersIcon;
      break;
    case 'documents':
      icon = <DocumentsIcon />;
      break;
    case 'main':
      icon = MainIcon;
      break;
    case 'agents':
      icon = AgentsIcon;
      break;
    case 'exchange':
      icon = <ExchangeIcon />;
      break;
    case 'company':
      icon = CompanyIcon;
  }

  return (
    <header className="header">
      <div className="header__left">
        <Breadcrumbs items={items ?? []} icon={icon} tabName={tabName} />
      </div>
      <div className="header__right">
        <BalanceHeaderContainer isHideBalanceInformer={isHideBalanceInformer} />
      </div>
    </header>
  );
};

export default PageHeader;
